<template>
  <v-row>
    <v-col> {{ filters }}</v-col>
  </v-row>
</template>

<script>
export default {
  name: "ExportLogsItemFilters",

  props: {
    value: {
      type: String,
      default: () => "",
    },
  },

  computed: {
    filters() {
      let filtersStr = "";
      if (this.value != "") {
        const criteria = JSON.parse(this.value);
        filtersStr = criteria.filter;
        console.log(criteria);
      }
      return filtersStr;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/logs/ExportLogsItemFilters.vue